// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IBlockTypeData {
  id?: number;
  name: string;
  icon?: string;
  shortId?: string;
  altShortId?: string;
  mapColor?: string;
}
